var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39909 2.53583H3.60809C2.35187 2.53583 1.3335 3.55417 1.3335 4.81036V12.3922C1.3335 13.6484 2.35187 14.6667 3.60809 14.6667H11.1901C12.4463 14.6667 13.4647 13.6484 13.4647 12.3922L13.4647 8.60127M5.12449 10.8758L7.88306 10.3199C8.02951 10.2904 8.16397 10.2183 8.26958 10.1127L14.4449 3.93415C14.741 3.63792 14.7408 3.15775 14.4445 2.86177L13.1363 1.55514C12.8401 1.25928 12.3602 1.25948 12.0642 1.55559L5.88823 7.73475C5.78283 7.8402 5.71086 7.97439 5.68133 8.12052L5.12449 10.8758Z",
    stroke: "#393736",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6fb32759bf9b39391fe64c6dd9d5619c.svg";
export { ForwardRef as ReactComponent };